/* eslint-disable @typescript-eslint/lines-between-class-members */
class Token {
  token_type!: string;
  expires_in!: string;
  ext_expires_in!: string;
  expires_on!: string;
  not_before!: string;
  resource!: string;
  access_token!: string;

  fromJSON(data: any): Token {
    return { ...this, ...data };
  }

  get authorization(): string {
    return `Bearer ${this.access_token}`;
  }
}
export default Token;
